const CopyIcon = () => {
    return (
        <svg className={"svg-icon"} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.75 15.7494H20.25V3.74939H8.25V8.24939" stroke="white" strokeWidth="2" strokeLinecap="round"
                  strokeLinejoin="round"/>
            <path d="M15.75 8.24951H3.75V20.2495H15.75V8.24951Z" stroke="white" strokeWidth="2" strokeLinecap="round"
                  strokeLinejoin="round"/>
        </svg>
    )
}

export default CopyIcon